<template>
  <div class="user-feedback-buttons">
    <span v-if="submitted && successMode === 'inline'" class="feedback-submitted">Thank you for your feedback</span>
    <template v-if="!submitted">
      <button class="feedback-button" @click="submitPositiveFeedback" :disabled="isSubmitting">
        <i class="mdi mdi-thumb-up-outline"></i>
      </button>
      <button class="feedback-button" @click="openFeedbackModal" :disabled="isSubmitting">
        <i class="mdi mdi-thumb-down-outline"></i>
      </button>
    </template>
  </div>
</template>

<script>
import to from '@/lib/to'
import UserFeedbackModal from '@/components/UserFeedbackModal.vue'

export default {
  name: 'UserFeedbackButtons',
  props: {
    feature: {
      type: String,
      required: true
    },
    metadata: {
      type: Object,
      default: () => ({})
    },
    successMode: {
      type: String,
      default: 'toast',
      validator: v => ['toast', 'inline'].includes(v)
    }
  },
  methods: {
    async submitPositiveFeedback() {
      if (this.isSubmitting) return
      this.isSubmitting = true
      const [err] = await to(this.$http.post('/user_feedbacks', {
        feature: this.feature,
        sentiment: 'positive',
        metadata: this.metadata
      }, { skipLoading: true }))

      this.isSubmitting = false
      if (err) {
        this.$buefy.toast.open({ message: 'Failed to submit feedback', type: 'is-danger', duration: 3000 })
        return
      }
      this.onFeedbackSubmitted()
    },
    onFeedbackSubmitted() {
      this.submitted = true
      if (this.successMode === 'toast') {
        this.$buefy.toast.open({ message: 'Thank you for your feedback', type: 'is-success', duration: 3000 })
      }
    },
    openFeedbackModal() {
      if (this.isSubmitting) return
      this.$buefy.modal.open({
        component: UserFeedbackModal,
        hasModalCard: false,
        props: {
          feature: this.feature,
          metadata: this.metadata
        },
        events: {
          submitted: () => {
            this.onFeedbackSubmitted()
          }
        }
      })
    }
  },
  data() {
    return {
      isSubmitting: false,
      submitted: false
    }
  }
}
</script>

<style scoped lang="scss">
.user-feedback-buttons {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.feedback-submitted {
  font-size: 12px;
  opacity: 0.8;
  text-transform: none;
  letter-spacing: normal;
}

.feedback-button {
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
  padding: 4px;
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:not(:disabled):hover {
    color: var(--ld-text-tertiary);
  }
  i {
    font-size: 18px;
  }
}
</style>
